import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { FetchIbanVerificationResponse, FetchIbanVerificationsResponse } from '../../../types/ibanVerifications';
import {
  fetchIbanVerification,
  fetchIbanVerifications,
  approveIbanVerification,
  rejectIbanVerification,
  cleanIbanVerifications,
  resetEditIbanVerification,
} from './ibanVerification.actions';
import { IbanVerificationState } from './ibanVerification.types';

const initialState: IbanVerificationState = {
  ibanVerifications: [],
  totalIbanVerifications: 0,
  editIbanVerification: null,
  fetchStatus: fetchStatuses.idle,
  approveStatus: fetchStatuses.idle,
  rejectStatus: fetchStatuses.idle,
  error: null,
};

const ibanVerificationsSlice = createSlice({
  name: 'ibanVerifications',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchIbanVerifications.pending, (state) => {
      state.error = null;
      state.fetchStatus = fetchStatuses.pending;
    });
    builder.addCase(
      fetchIbanVerifications.fulfilled,
      (state, action: PayloadAction<FetchIbanVerificationsResponse>) => {
        state.ibanVerifications = action.payload.data?.items;
        state.totalIbanVerifications = action.payload.data?.totalItems;
        state.fetchStatus = fetchStatuses.success;
      },
    );
    builder.addCase(fetchIbanVerifications.rejected, (state, action) => {
      state.fetchStatus = fetchStatuses.rejected;
      state.error = action.error;
    });

    builder.addCase(fetchIbanVerification.pending, (state) => {
      state.error = null;
      state.fetchStatus = fetchStatuses.pending;
    });
    builder.addCase(fetchIbanVerification.fulfilled, (state, action: PayloadAction<FetchIbanVerificationResponse>) => {
      state.editIbanVerification = action.payload.data;
      state.fetchStatus = fetchStatuses.success;
    });
    builder.addCase(fetchIbanVerification.rejected, (state, action) => {
      state.fetchStatus = fetchStatuses.rejected;
      state.error = action.error;
    });

    builder.addCase(approveIbanVerification.pending, (state) => {
      state.error = null;
      state.approveStatus = fetchStatuses.pending;
      state.rejectStatus = fetchStatuses.idle;
    });
    builder.addCase(approveIbanVerification.fulfilled, (state) => {
      state.approveStatus = fetchStatuses.success;
    });
    builder.addCase(approveIbanVerification.rejected, (state, action) => {
      state.approveStatus = fetchStatuses.rejected;
      state.error = action.error;
    });

    builder.addCase(rejectIbanVerification.pending, (state) => {
      state.error = null;
      state.rejectStatus = fetchStatuses.pending;
      state.approveStatus = fetchStatuses.idle;
    });
    builder.addCase(rejectIbanVerification.fulfilled, (state) => {
      state.rejectStatus = fetchStatuses.success;
    });
    builder.addCase(rejectIbanVerification.rejected, (state, action) => {
      state.rejectStatus = fetchStatuses.rejected;
      state.error = action.error;
    });

    builder.addCase(resetEditIbanVerification.type, (state) => {
      state.editIbanVerification = null;
      state.fetchStatus = fetchStatuses.idle;
      state.approveStatus = fetchStatuses.idle;
      state.rejectStatus = fetchStatuses.idle;
      state.error = null;
    });

    builder.addCase(cleanIbanVerifications.type, (state) => {
      Object.assign(state, initialState);
    });
  },
});

export const ibanVerificationReducer = ibanVerificationsSlice.reducer;
